import React from "react";
import "./star-ratings.m.css";

const FullStar = () => <span styleName="star">★</span>;
const HalfStar = () => <span styleName="star half"></span>;
const EmptyStar = () => <span styleName="star empty"></span>;

const StarRating = ({ story }) => {
  const rating = story?.metadata["review-rating"]?.value || 0;
  const floatRating = parseFloat(rating);
  const totalStars = 5;
  const stars = [];

  for (let i = 1; i <= totalStars; i++) {
    if (floatRating >= i) {
      stars.push(<FullStar key={i} />);
    } else if (floatRating >= i - 0.5) {
      stars.push(<HalfStar key={i} />);
    } else {
      stars.push(<EmptyStar key={i} />);
    }
  }
  return <div styleName="star-rating-container">{stars}</div>;
};

export default StarRating;
